var React = require('react');

function DropdownInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"id":"DropdownIcon","key":0},"Dropdown icon"),React.createElement("desc",{"id":"ExpandDropDown","key":1},"An icon that expands others option from the menu"),React.createElement("path",{"d":"M0.877197 0.666748L4.21053 4.00008L7.54386 0.666748H0.877197Z","fill":"#323232","key":2})]);
}

DropdownInline.defaultProps = {"width":"8","height":"4","viewBox":"0 0 8 4","fill":"none"};

module.exports = DropdownInline;

DropdownInline.default = DropdownInline;
